import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentEmpid, selectIsDelegate } from '../../../pages/login/authSlice';
import { datetimeToDate } from '../../../utils/dateFormat';
import { CaStatusNames } from '../../../utils/typeConstants';
import { useGetCaManagerTlSearchQuery } from '../managerTlViewSearch/CaMangerTLView.slice';
import { MyDashboardTable } from '../myDashboardTable/MyDashboardTable';
import { caDetails } from '../type';
import './myDashboard.scss';

interface CaDashboardProps {
    setActiveIndex?: (e: number) => void;
    setSelectedEmployee: (e: caDetails | undefined) => void;
    setVia?: (e: string) => void;
    fromPage?: string;
}

export const MyDashboardCa = (props: CaDashboardProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const isDelegate = useSelector<boolean | undefined | null>(selectIsDelegate);
    const toast = useRef<Toast | null>(null);
    const [myDashboardData, setMyDashboardData] = useState<any>([]);

    const [creationEndDate, setCreationEndDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());

    const setCreationDate = () => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 90);
        return currentDate;
    };
    const [creationStartDate, setCreationStartDate] = useState<Date>(() => setCreationDate());

    const { data: caMangerTlDataSlice } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: loggedEmpNum,
            CreationStartDate: datetimeToDate(creationStartDate),
            CreationEndDate: endDate ? datetimeToDate(endDate) : '',
        },
        {
            skip: !loggedEmpNum || isDelegate,
        }
    );
    useEffect(() => {
        if (caMangerTlDataSlice?.data?.length > 0) {
            if (props.fromPage === 'scorecardDashboard') {
                const filteredCA = caMangerTlDataSlice.data.filter(
                    (data: any) => data.ca_status_name === CaStatusNames.Release
                );
                setMyDashboardData(filteredCA);
            } else {
                const filteredCA = caMangerTlDataSlice.data.filter(
                    (data: any) => data.ca_status_name === CaStatusNames.Release || data.ca_status_name === CaStatusNames.Acknowledged
                );
                setMyDashboardData(filteredCA);
            }
        } else {
            setMyDashboardData([]);
        }
    }, [caMangerTlDataSlice]);

    const changeCreationStartDate = (e: any) => {
        setCreationStartDate(e.value);
    };

    const changecreationEndDate = (e: any) => {
        if (e.value) {
            const date = new Date(e.value);
            date.setDate(date.getDate());
            setCreationEndDate(e.value);
            setEndDate(date);
        } else {
            setCreationEndDate(null);
            setEndDate(null);
        }
    };

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <div className="row mt-4">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="recipientName">Start Date</label>
                        <Calendar
                            id="icon"
                            value={creationStartDate}
                            dateFormat="dd-M-yy"
                            onChange={changeCreationStartDate}
                            showIcon
                            className="custom-calendar"
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="recipientName">End Date</label>
                        <Calendar
                            id="icon"
                            value={creationEndDate}
                            dateFormat="dd-M-yy"
                            onChange={changecreationEndDate}
                            showButtonBar
                            showIcon
                            className="custom-calendar"
                        />
                    </div>
                </div>
            </div>
            <MyDashboardTable
                fromPage={props.fromPage}
                setActiveIndex={props.setActiveIndex}
                setVia={props.setVia}
                setSelectedEmployee={props.setSelectedEmployee}
                dashboardData={myDashboardData}
            />
        </>
    );
};
